export const LocalePickerStyles = {
  container: 'my-5 flex flex-row justify-center text-black',
  button: 'cursor-pointer text-black text-base underline uppercase',
}
